import { GET_PDF_DATA, GET_PDF_DATA_SUCCESS } from './ToDownload.actions'

const pdfData = {
  loading: true
}

/**
 * The pdf data section reducer.
 */
const pdfDataReducer = (state = pdfData, { type }) => {
  switch (type) {
    case GET_PDF_DATA: {
      return { ...state, loading: true }
    }
    case GET_PDF_DATA_SUCCESS: {
      return {
        ...state,
        loading: false
      }
    }
    default: {
      return state
    }
  }
}

export default pdfDataReducer
